module.exports = __webpack_public_path__ + "img/ipadpro2_splash.0dd1fce8.png";